export default "__VITE_ASSET__CNKk7SOe__"